import gql from 'graphql-tag';

import { AlbumFolderMainCoverPhoto } from '../../../../../../../graphql/fragments/album-folder';
import { PhotoThumbnails } from '../../../../../../../graphql/fragments/album';

export const MatchesAlbumFolderDetails = gql`
  fragment MatchesAlbumFolderDetails on AlbumFolder {
    id
    name
    join_code
    join_type
    joins_enabled
    matching_disabled
    org_pay_photo_pricing_enabled
    album_type
    album_subtype
    upload_mode
    file_comment_privacy
    picture_day_enabled
    has_album_photos
    all_photos_mode
    join_type
    is_web_gallery
  }
`;

export const MatchesAlbumFolderChildrenDetails = gql`
  fragment MatchesAlbumFolderChildrenDetails on AlbumFolder {
    children {
      album_folders(slice: { limit: 999 }) {
        total
        records {
          id
          name
          updated_at
          is_web_gallery
          cover_photos {
            records {
              ...PhotoThumbnails
            }
          }
          ...AlbumFolderMainCoverPhoto
        }
      }
      albums(
        slice: { limit: 999 }
        exclude_albums_with_viewer_album_membership: $exclude_albums_with_memberships
      ) {
        total
        records {
          id
          name
          cover_photo {
            ...PhotoThumbnails
          }
          join_code
          last_uploaded_at
          is_web_gallery
        }
      }
    }
  }
  ${AlbumFolderMainCoverPhoto}
  ${PhotoThumbnails}
`;
